export const PAUSE_OUTSIDE_POLICY = {
  caseType: 'Support',
  caseRecordType: 'Cancellation',
  caseCategory: 'Customer led',
  caseSubCategory: 'Pause extension outside of policy',
};
